module.exports = __webpack_public_path__ + "assets/img/evaluation-top-bg.6b9dd5f9.png";